import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Badge } from "reactstrap";
import { firestore } from '../../helpers/Firebase';
import { accessTypes, accessTypesObject } from "../../helpers/Utils";
import { Colxx } from "./CustomBootstrap";
import CustomSelectInput from "./CustomSelectInput";

const providersStatusOptions = [
  { key: "all", value: "All", label: "All" },
  { key: "active", value: "Active", label: "Active" },
  { key: "closed", value: "Closed", label: "Closed" }
];

const providersSubscriptionStatus = [
  { key: "all", value: "All", label: "All" },
  { key: "active", value: "Enabled", label: "Enabled" },
  { key: "disabled", value: "Disabled", label: "Disabled" }
];

const ProvidersFilter = ({ onFiltersChange, admins, serviceFilterId, onServiceFilterChange }) => {
  const { user } = useSelector(state => state.authUser);
  const { provider: providers, services, advServices } = useSelector(state => state.providers);

  // Build a flat list of all services for the picker. `services` + `advServices`
  // together cover regular wash services + PPF/tinting/etc.
  const serviceOptions = React.useMemo(() => {
    const all = [
      ...Object.values(services || {}),
      ...Object.values(advServices || {}),
    ];
    return all
      .filter(s => s && (s.id || s.key))
      .map(s => ({
        key: s.id || s.key,
        value: s.name || s.name_ar || (s.id || s.key),
        label: s.name || s.name_ar || (s.id || s.key),
      }));
  }, [services, advServices]);

  const [subscriptionData, setSubscriptionData] = useState({});
  const [filter, setFilter] = useState({
    providersStatus: 'all',
    joiningRange: false,
    expiringRange: false,
    renewalRange: false,
    subscriptionState: '',
    responsibleAgent: false
  });

  // Fetch subscription data
  useEffect(() => {
    let subscriptionsSnapshot = firestore().collectionGroup('subscriptions').onSnapshot(snapshot => {
      let subscriptions = snapshot.docs.map(doc => doc.ref.parent.parent.id);
      setSubscriptionData(subscriptions);
    });
    return () => subscriptionsSnapshot();
  }, []);

  // Filter providers logic
  const filterProvidersList = () => {
    const { providersStatus, joiningRange, expiringRange, renewalRange, subscriptionState, responsibleAgent } = filter;
    let filteredBranches = Object.values(providers || {})?.filter(provider => {
      const isActive = providersStatus && providersStatus !== 'all'
        ? (providersStatus === 'active' ? provider.active : !provider?.active)
        : true;

      const isJoiningDateValid = joiningRange ? (provider?.joiningDate
        ? (joiningRange?.length ? moment(provider.joiningDate).isBetween(moment(joiningRange[0]), moment(joiningRange[1])) : true)
        : false) : true;

      const isExpiryDateValid = expiringRange ? (provider?.expiryDate
        ? (expiringRange?.length ? moment(provider.expiryDate).isBetween(moment(expiringRange[0]), moment(expiringRange[1])) : true)
        : false) : true;

      const isRenewalDateValid = renewalRange ? (provider?.renewalDate
        ? (renewalRange?.length ? moment(provider.renewalDate).isBetween(moment(renewalRange[0]), moment(renewalRange[1])) : true)
        : false) : true;

      const isSubscriptionEnabled = subscriptionState && subscriptionState !== 'all'
        ? (subscriptionState === 'active' ? subscriptionData?.includes(provider?.key || provider?.id) : !subscriptionData?.includes(provider?.key || provider?.id))
        : true;

      const isResponsibleAgent = responsibleAgent ? (provider?.agent === responsibleAgent) : true;

      return isActive && isExpiryDateValid && isJoiningDateValid && isRenewalDateValid && isSubscriptionEnabled && isResponsibleAgent;
    });

    // Call the callback function to update parent component
    if (onFiltersChange) {
      onFiltersChange(filteredBranches);
    }
  };

  // Apply filters when filter state changes
  useEffect(() => {
    filterProvidersList();
    // eslint-disable-next-line
  }, [filter, providers, subscriptionData]);

  // Only render for users with appropriate access
  if (!accessTypes.includes(user?.accessType)) {
    return null;
  }

  return (
    // <Row>
    <>
      <Colxx xxs="12" md="3" className='mb-3' >

        <Select
          components={{ Input: CustomSelectInput }}
          className="basic-multi-select"
          placeholder="Filter Service Providers"
          value={providersStatusOptions.find(option => option.key === filter?.providersStatus)}
          options={providersStatusOptions}
          onChange={val => {
            if (val) {
              setFilter({ ...filter, providersStatus: val.key });
            } else {
              setFilter({ ...filter, providersStatus: false });
            }
          }}
        />
      </Colxx>
      <Colxx xxs="12" md="3" className='mb-3'  >
        <Select
          isClearable={true}
          components={{ Input: CustomSelectInput }}
          className="basic-multi-select"
          placeholder="Filter Responsible Agent"
          value={admins?.map(rec => {
            return (filter?.responsibleAgent === (rec.key)) ?
              ({ ...rec, value: rec.name, label: rec.name, key: rec.id || rec.key }) : ''
          })}
          options={admins?.map(rec => {
            return ({ ...rec, value: rec.name, label: rec.name, key: rec.id || rec.key })
          })}
          getOptionLabel={option => {
            return (
              <div>
                {option.name}
                <Badge color={'primary'} className={'ml-2'} style={{ fontSize: '0.6rem' }} pill>
                  {accessTypesObject?.[option.role]?.name}
                </Badge>
              </div>
            )
          }}
          getOptionValue={(option) => { return option.key || option.id }}
          onChange={val => {
            if (val) {
              setFilter({ ...filter, responsibleAgent: val.key });
            } else {
              setFilter({ ...filter, responsibleAgent: false });
            }
          }}
        />
      </Colxx>
      <Colxx xxs="12" md="3" className='mb-3'  >

        <Select
          isClearable={true}
          components={{ Input: CustomSelectInput }}
          className="basic-multi-select"
          placeholder="Filter Subscription Enabled"
          value={providersSubscriptionStatus.find(option => option.key === filter?.subscriptionState)}
          options={providersSubscriptionStatus}
          onChange={val => {
            if (val) {
              setFilter({ ...filter, subscriptionState: val.key });
            } else {
              setFilter({ ...filter, subscriptionState: false });
            }
          }}
        />
      </Colxx>
      <Colxx xxs="12" md="3" className='mb-3'  >
        <Select
          isClearable={true}
          components={{ Input: CustomSelectInput }}
          className="basic-multi-select"
          placeholder="Rate by service"
          value={serviceOptions.find(option => option.key === serviceFilterId) || null}
          options={serviceOptions}
          onChange={val => {
            if (onServiceFilterChange) onServiceFilterChange(val ? val.key : null);
          }}
        />
      </Colxx>
      <Colxx xxs="12" md="3" className='mb-3'    >

        <DatePicker
          onChange={(dates) => {
            let filterDates = dates?.filter(date => date);
            setFilter({ ...filter, joiningRange: filterDates });
          }}
          placeholderText="Select Joining Date"
          isClearable={true}
          startDate={filter?.joiningRange?.[0]}
          endDate={filter?.joiningRange?.[1]}
          selectsRange={true}
          dateFormat={'dd/MM/yyyy'}
        />
      </Colxx>
      <Colxx xxs="12" md="3" className='mb-3'    >

        <DatePicker
          onChange={(dates) => {
            let filterDates = dates?.filter(date => date);
            setFilter({ ...filter, expiringRange: filterDates });
          }}
          isClearable={true}
          placeholderText="Select Expiry Date"
          startDate={filter?.expiringRange?.[0]}
          endDate={filter?.expiringRange?.[1]}
          selectsRange={true}
          dateFormat={'dd/MM/yyyy'}
        />
      </Colxx>

      <Colxx xxs="12" md="3" className='mb-3'    >

        <DatePicker
          onChange={(dates) => {
            let filterDates = dates?.filter(date => date);
            setFilter({ ...filter, renewalRange: filterDates });
          }}
          isClearable={true}
          placeholderText="Select Renewal Date"
          startDate={filter?.renewalRange?.[0]}
          endDate={filter?.renewalRange?.[1]}
          selectsRange={true}
          dateFormat={'dd/MM/yyyy'}
        />
      </Colxx>



    </>);
};

export default ProvidersFilter;
